
<div
  class="so-overview d-flex"
  :class="{
    'justify-content-between': showTemplates,
    'justify-content-left': !showTemplates,
  }"
>
  <div
    v-if="!occurrence.isCompleted"
    :class="{
      'col-4': showTemplates,
    }"
  >
    <div v-if="showTemplates" class="overview-label">
      <div class="d-flex justify-content-between">
        <div>Task Generation / Templates</div>
        <div>
          <button class="btn btn-block rounded-pill btn-primary btn-xs mt-1 pl-3 pr-3" @click="showTemplates = !showTemplates">
            Hide
          </button>
        </div>
      </div>
    </div>

    <div v-if="!showTemplates" class="templates-vertical-panel d-flex justify-content-left">
      <div class="overview-label">Task Generation / Templates</div>
      <button class="ml-2 btn btn-block rounded-pill btn-primary btn-xs mt-1 pl-3 pr-3" @click="showTemplates = !showTemplates">
        Show
      </button>
    </div>

    <div v-if="showTemplates">
      <div class="mt-2 mb-2">
        <div class="input-group mb-3">
          <input type="text" class="form-control input-sm" placeholder="Search..." v-model="search" />
          <div class="input-group-append">
            <i class="fa fa-search input-group-text pb-0"></i>
          </div>
        </div>
      </div>
      <div>
        <div class="mb-3" v-for="tInfo in templates" :key="tInfo.boardId">
          <div class="justify-content-between d-flex align-items-center mt-1 mb-2">
            <div class="board-label label">{{ tInfo.boardTitle }}</div>
            <div>
              <button
                class="create-board-item-btn btn btn-block rounded-pill btn-info btn-xs pl-2 pr-2"
                @click="addNewBoardItem(tInfo.boardId)"
              >
                <i class="fas fa-plus"></i>
                Create Task
              </button>
            </div>
          </div>
          <div v-for="template in tInfo.filteredTemplates" :key="template.id">
            <div class="so-template">
              <div class="so-template-header d-flex justify-content-between">
                <div class="d-flex justify-content-between">
                  <div class="cursor-pointer ml-2 mr-2" v-on:click="toggleTemplate(tInfo.boardId, template.id)">
                    <i v-if="isOpened(tInfo.boardId, template.id)" class="fas fa-angle-up"></i>
                    <i v-else class="fas fa-angle-down"></i>
                  </div>

                  <div>
                    <div>{{ template.boardItemType.boardItemCategory.name }}</div>
                    <div>{{ template.title }}</div>
                    <div v-if="template.checklists && template.checklists.length">
                      <i class="fas fa-tasks"></i>
                      {{ template.checklists.length }}
                    </div>
                  </div>
                </div>

                <div
                  v-b-tooltip.hover
                  :title="
                    template.requiresParam && (!occurrence.flights || !occurrence.flights.length)
                      ? 'This template requires a selected flight on the data page.'
                      : ''
                  "
                >
                  <!-- Template doesn't require params -->
                  <button
                    v-if="!template.requiresParam"
                    class="create-template-btn btn btn-xs btn-primary rounded-pill mr-1"
                    @click="createBoardItem(tInfo.boardId, template.id)"
                    :disabled="loadingTemplateIds.includes(template.id)"
                  >
                    <i class="fas fa-plus" v-if="!loadingTemplateIds.includes(template.id)"></i>
                    <i class="fas fa-spinner fa-spin" v-if="loadingTemplateIds.includes(template.id)"></i>
                    Create
                  </button>

                  <!-- Template requires params and one flight was selected -->
                  <button
                    v-if="template.requiresParam && occurrence.flights && occurrence.flights.length === 1"
                    class="create-template-btn btn btn-xs btn-primary rounded-pill mr-1"
                    @click="createBoardItem(tInfo.boardId, template.id, occurrence.flights[0].id)"
                    :disabled="loadingTemplateIds.includes(template.id)"
                  >
                    <i class="fas fa-plus" v-if="!loadingTemplateIds.includes(template.id)"></i>
                    <i class="fas fa-spinner fa-spin" v-if="loadingTemplateIds.includes(template.id)"></i>
                    Create
                  </button>

                  <!-- Template requires params and more then one flight was selected -->
                  <button
                    v-if="template.requiresParam && (!occurrence.flights.length || (occurrence.flights && occurrence.flights.length > 1))"
                    v-bind:id="'createItemFromTemplate_' + template.id + '_' + tInfo.boardId"
                    class="create-template-btn btn btn-xs btn-primary rounded-pill mr-1"
                    :disabled="!occurrence.flights || !occurrence.flights.length"
                  >
                    <i class="fas fa-plus"></i>
                    Create
                  </button>

                  <b-popover
                    custom-class="wide-popover"
                    v-bind:ref="'createItemFromTemplateRef_' + template.id + '_' + tInfo.boardId"
                    v-bind:target="'createItemFromTemplate_' + template.id + '_' + tInfo.boardId"
                    triggers="click blur"
                    v-if="template.requiresParam && occurrence.flights && occurrence.flights.length > 1"
                  >
                    <div class="mt-1 mb-1">
                      <div class="label d-flex align-items-center justify-content-center">Choose a flight</div>

                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th scope="col"></th>
                            <th scope="col">Date</th>
                            <th scope="col">Flight</th>
                            <th scope="col">Departure-Arrival</th>
                            <th scope="col">Registration</th>
                            <th scope="col">Reason</th>
                            <th scope="col">Comment</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="flight in filteredSelectedFlights(occurrence.flights)" :key="flight.id">
                            <td>
                              <button
                                class="create-template-btn btn btn-xs btn-primary"
                                @click="createBoardItem(tInfo.boardId, template.id, flight.id)"
                                :disabled="loadingTemplateIds.includes(template.id)"
                              >
                                <i class="fas fa-plus" v-if="!loadingTemplateIds.includes(template.id)"></i>
                                <i class="fas fa-spinner fa-spin" v-if="loadingTemplateIds.includes(template.id)"></i>
                                Select
                              </button>
                            </td>
                            <td>{{ flight.date | formatDateWithoutHours }}</td>
                            <td>{{ flight.flightNo }}</td>

                            <td>{{ flight.departureAirport }} - {{ flight.arrivalAirport }}</td>

                            <td>{{ flight.aircraftRegistration }}</td>
                            <td>{{ flight.selectedReason }}</td>
                            <td>{{ flight.selectedReasonComment }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-popover>
                </div>
              </div>

              <div class="so-template-content" v-if="isOpened(tInfo.boardId, template.id)">
                {{ template.description }}

                <div v-for="list in template.checklists" :key="list.id">
                  <div v-if="list.items" class="mt-1">
                    <div class="mt-2 label">{{ list.title }}</div>

                    <div class="checklist-items">
                      <div v-for="listItem in list.items" :key="listItem.title">
                        <div class="checklist-item ml-3">
                          <b-form-checkbox disabled>
                            <div class="ml-1 checkbox-label">
                              {{ listItem.title }}
                            </div>
                          </b-form-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    :class="{
      'col-8': showTemplates && !occurrence.isCompleted,
      'col-12': occurrence.isCompleted,
    }"
    style="margin-left: -10px"
  >
    <div class="overview-label mb-2">Task Overview</div>

    <div v-for="boardInfo in soBoards" :key="boardInfo.boardId">
      <div v-if="boardInfo.items && boardInfo.items.length">
        <div class="mt-4 label w-100 bg-active">
          <strong>{{ boardInfo.boardTitle }}</strong>
          <hr />
        </div>

        <div class="d-flex">
          <div class="mr-4 containers" v-for="list in boardLists" :key="list">
            <div v-for="item in filteredBoardItems(list, boardInfo.items, boardInfo.boardId)" :key="item.id">
              <div v-if="item">
                <task-card :item="item" :isSO="true" class="m-1"></task-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showNoAvailableTasks">
      <div class="no-available-items">There are no available Tasks</div>
    </div>
  </div>

  <router-view></router-view>
</div>
